import Sidemenu from "../layout/sidemenu";
import Header from "../layout/header";
import React, { useState, useEffect } from "react";
import { NoAuthApiRequest,ApiRequest } from "./services/apiservice";
import { ApiEndpoints,ApiEndpointMethod } from "../utils/endpoints";
import { useNavigate } from "react-router";
import { saveAs } from 'file-saver';
import  Loader from './shared/loader';
import { toast } from "react-toastify";
import Select from 'react-select';

const Reports = () => {
    const [loader,setloader]=useState(false);
    const [IsConvertTime,setIsConvertTime]=useState(false);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const usrDetails = JSON.parse(localStorage.getItem("user"));
    const [DownloadedBy,setDownloadedBy]=useState([]);
    const [Users,setUsers]=useState([]);
    const [Projects,setProjects]=useState([]);
    const navigate = useNavigate();
    const [selectedOption,setselectedOption]=useState();
    const [userList,setuserList]=useState([]);

    const [selectedProjectOption,setselectedProjectOption]=useState();
    const [projectList,setprojectList]=useState([]);

    const [formData, setFormData] = useState({
        Year:"",
        Month:"",
        DownloadBy:"",
        UserId:"",
        ProjectId:""
    });

    const optionsByRole = {
        admin: [
            { value: 'ByTeamMember', text: 'By Employee' },
            { value: 'ByTeamProject', text: 'By Project' },
            { value: 'LowerTimeByWeek', text: 'Defaulters List' },
            { value: 'LowerTimeByMonth', text: 'Defaulters List by Month' },
            { value: 'ProjectTimeByWeek', text: 'Weekly Report By Project' },
            { value: 'ProjectTimeByMonth', text: 'Monthly Report By Project' },
        ],
        lead: [
            { value: 'ByProject', text: 'By Project' },
            { value: 'MySheet', text: 'My Sheet' },
            { value: 'ByTeamMember', text: 'By Team Member' },
            { value: 'ByTeamProject', text: 'By Team Project' },
        ],
        employee: [
          { value: 'ByProject', text: 'By Project' },
          { value: 'MySheet', text: 'My Sheet' }
        ]
      };

      useEffect(() => {
        const options = optionsByRole[usrDetails?.RoleName] || [];
        const opt=[];
        options.forEach(option => {
            opt.push({value:option.value,text:option.text})
          });
          setDownloadedBy(opt);

          if(usrDetails?.RoleName=="admin"|| usrDetails?.RoleName=="lead"){
                 const fetchData = async () => {
                           await FetchUsers();
                           await FetchProject();
                         };
            fetchData();
          }
      }, []);

      const downloadExcelFile = (base64String,filename) => {
        // Decode the base64 string
        const byteCharacters = atob(base64String);
        const byteArrays = [];
    
        // Create a byte array
        for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
          const slice = byteCharacters.slice(offset, offset + 1024);
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          byteArrays.push(new Uint8Array(byteNumbers));
        }
    
        // Create a Blob from the byte array
        const blob = new Blob(byteArrays, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
        // Trigger the file download
        saveAs(blob, filename+'.xlsx');
      };

      const convertTime =async()=>{
        setIsConvertTime(!IsConvertTime);
      }

       const DownloadReport = async() => {
      //alert(IsConvertTime)
        try{
          var filename="";
        var UserId =usrDetails?.Id;
        if(formData.DownloadBy=="ByTeamMember"||formData.DownloadBy=="ByTeamProject"){
            UserId='';
        }
        if(formData.Year==""||formData.Year==null||formData.Year==undefined){
            toast.error("Please select the Year", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
               });
               return true;
        }
        if(formData.Month==""||formData.Month==null||formData.Month==undefined){
            toast.error("Please select the Month", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
               });
               return true;
        }
        if(formData.DownloadBy==""||formData.DownloadBy==null||formData.DownloadBy==undefined){
            toast.error("Please select the DownloadBy", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
               });
               return true;
        }
        if(formData.DownloadBy=="ByTeamMember"){
            if(formData.UserId==""||formData.UserId==null||formData.UserId==undefined){
                toast.error("Please select the User", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                   });
                   return true;
            }
        }
        if(formData.DownloadBy=="ByTeamProject"){
            if(formData.ProjectId==""||formData.ProjectId==null||formData.ProjectId==undefined){
                toast.error("Please select the Project", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                   });
                   return true;
            }
        }
        setloader(true);
        const data = await ApiRequest(
            ApiEndpoints.Entity.DownloadReport(UserId,formData.ProjectId,formData.UserId,formData.Year,formData.Month,formData.DownloadBy,IsConvertTime),
            ApiEndpointMethod.Post,
            null,
            navigate
            );
            if(data.success){

               var download = DownloadedBy.filter(x=>x.value==formData.DownloadBy);
               if(download != null && download.length>0){
                filename = download[0].text;
               }
               filename = filename+'_'+ await getMonthName(formData.Month)+'_'+formData.Year;
              //  console.log(download);
              //  alert(filename);
              await downloadExcelFile(data.MemoryStream,filename);
            }
            else{
                     toast.error(data.message, {
                                 position: "top-right",
                                 autoClose: 3000,
                                 hideProgressBar: false,
                                 closeOnClick: true,
                                 pauseOnHover: true,
                                 draggable: true,
                                 progress: undefined,
                                 theme: "light",
                                });
            }
        }
        catch(err){

        }
        finally{
            setloader(false);
        }
       }

       const getMonthName = async(monthNumber) => {
        const monthNames = [
          "January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December"
        ];
        return monthNames[monthNumber - 1]; // Adjust for 0-based array indexing
      }

      const FetchUsers = async()=>{
        if(usrDetails?.RoleName=="admin"){
                 const data = await ApiRequest(
                     ApiEndpoints.User.FetchUser,
                     ApiEndpointMethod.Get,
                     null,
                     navigate
                     );
                     setUsers(data.Item1);
                     const options = [];
                     options.push({ value: '', label: '--Select--' })
                     data.Item1.forEach(x=>{
                      options.push({ value: x.Users.Id, label: x.Users.Name })
                     })
                     setselectedOption({ value: '', label: '--Select--' });
                    setuserList(options);
                    await handleChangeTigger("UserId",'');
        }
        else if(usrDetails?.RoleName=="lead"){

            const data1 = await ApiRequest(ApiEndpoints.User.FetchLeadUserMapping(usrDetails?.Id), ApiEndpointMethod.Post, null, navigate);
                if(data1 != null){
                    setUsers(data1.Item2);
debugger;
                    const options = [];
                     options.push({ value: '', label: '--Select--' })
                     data1.Item2.forEach(x=>{
                      options.push({ value: x.Id, label: x.Name })
                     })
                     setselectedOption({ value: '', label: '--Select--' });
                    setuserList(options);
                    await handleChangeTigger("UserId",'');

                }

        }
      }

      const FetchProject = async() => {
                const data = await ApiRequest(
                  ApiEndpoints.Entity.FetchProjectByUser(usrDetails.Id),
                  ApiEndpointMethod.Get,
                  null,
                  navigate
                  );
                   data.sort((a, b) => a.Name.localeCompare(b.Name));
                  setProjects(data);
                  debugger;

                  const options = [];
                  options.push({ value: '', label: '--Select--' })
                  data.forEach(x=>{
                   options.push({ value: x.Id, label: x.Name })
                  })
                  setselectedProjectOption({ value: '', label: '--Select--' });
                 setprojectList(options);
                 await handleChangeTigger("ProjectId",'');
      }

      const handleChange = async (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
      
        if(name=="DownloadBy" && value=="ByTeamMember"){
            await handleChangeTigger("ProjectId",'');
        }
        else if(name=="DownloadBy" && value=="ByTeamProject"){
            await handleChangeTigger("UserId",'');
        }
    };

    const handleChangeTigger = (name, value) => {
        setFormData((prevState) => ({
         ...prevState,
         [name]: value,
       }));
 };

 const handleChanges = async(selectedOption) => {
  console.log('Selected:', selectedOption);
  await handleChangeTigger("UserId",selectedOption.value);
  setselectedOption(selectedOption);
};

const handleChangeProject = async(selectedOption) => {
  console.log('Selected:', selectedOption);
  await handleChangeTigger("ProjectId",selectedOption.value);
  setselectedProjectOption(selectedOption);
};


    return (
        <>
            <div className={`workspace-wrapper ${isCollapsed ? "collapsed" : ""}`}>
                <Sidemenu />
                <div className="workspace">
                    <Header toggleCollapse={() => setIsCollapsed(!isCollapsed)} />
                    <div className="workspace-content">
                        <h5 className="mb-2">Download Timesheet</h5>
                        <div className="card rounded-0">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-3">
                                        <label>Year</label>
                                        <select className="form-control" name="Year" value={formData.Year}  onChange={handleChange}>
                                           <option value="">--Select--</option>
                                            <option value={2025}>2025</option>
                                            <option value={2026}>2026</option>
                                        </select>
                                    </div>

                                    <div className="col-lg-3">
                                        <label>Month</label>                                        
                                        <select className="form-control" name="Month" value={formData.Month}  onChange={handleChange}>
                                        <option value="">--Select--</option>
                                            <option value={1}>Jan</option>
                                            <option value={2}>Feb</option>
                                            <option value={3}>Mar</option>
                                            <option value={4}>Apr</option>
                                            <option value={5}>May</option>
                                            <option value={6}>Jun</option>
                                            <option value={7}>Jul</option>
                                            <option value={8}>Aug</option>
                                            <option value={9}>Sep</option>
                                            <option value={10}>Oct</option>
                                            <option value={11}>Nov</option>
                                            <option value={12}>Dec</option>
                                        </select>
                                    </div>

                                    <div className="col-lg-3">
                                        <label>Download By</label>
                                        <select className="form-control"  name="DownloadBy" value={formData.DownloadBy}  onChange={handleChange}>
                                        <option value="">--Select--</option>
                                        {DownloadedBy?.map((proj) => (
                                                    <option value={proj.value}>
                                                            {proj.text}
                                                    </option>
                                                ))}
                                        {/* <option value="ByProject">By Project</option>
                                        <option value="MySheet">My Sheet</option> */}
                                        </select>
                                    </div>
                                    {formData.DownloadBy === "ByTeamMember" && (
  usrDetails?.RoleName === "admin" ? (
    <div className="col-lg-3">
      <label>Users</label>
      <Select
        options={userList}
        onChange={handleChanges}
        isSearchable
        placeholder="Select a user..."
        value={selectedOption}
      />
      {/* <select 
        className="form-control" 
        name="UserId" 
        value={formData.UserId}  
        onChange={handleChange}
      >
        <option value="">--Select--</option>
        {Users?.map((proj) => (
          <option key={proj.Users.Id} value={proj.Users.Id}>
            {proj.Users.Name}
          </option>
        ))}
      </select> */}
    </div>
  ) : (
    <div className="col-lg-3">
      <label>Users</label>
      <Select
        options={userList}
        onChange={handleChanges}
        isSearchable
        placeholder="Select a user..."
        value={selectedOption}
      />
      {/* <select 
        className="form-control" 
        name="UserId" 
        value={formData.UserId}  
        onChange={handleChange}
      >
        <option value="">--Select--</option>
        {Users?.map((proj) => (
          <option key={proj.Id} value={proj.Id}>
            {proj.Name}
          </option>
        ))}
      </select> */}
    </div>
  )
)}

                                    {formData.DownloadBy=="ByTeamProject" &&(

                                    <div className="col-lg-3">
                                        <label>Projects</label>      
                                        <Select
        options={projectList}
        onChange={handleChangeProject}
        isSearchable
        placeholder="Select a project..."
        value={selectedProjectOption}
      />                                  
                                        {/* <select className="form-control"  name="ProjectId" value={formData.ProjectId}  onChange={handleChange}>
                                        <option value="">--Select--</option>
                                        {Projects?.map((proj) => (
                                                    <option value={proj.Id}>
                                                            {proj.Name}
                                                    </option>
                                                ))}
                                        </select> */}
                                    </div>
                                    )}
                                    {(formData.DownloadBy=="ByTeamProject" ||
                                    formData.DownloadBy=="ByProject"||
                                    formData.DownloadBy=="MySheet" ||
                                    formData.DownloadBy=="ByTeamMember") && (
                                     <div className="col-lg-3">
                                        <label className="invisible"></label>
                                        <div style={{padding: "4px",display: "flex",alignItems: "center"}}>
                                          <input type="checkbox" style={{width:"25px",height:"25px"}} name="converttime" id="chkconverttime" 
                                          value={IsConvertTime} onChange={convertTime}></input>
                                          <span>Convert To Time</span>
                                        </div>
                                    </div>
                                    )}

                                    <div className="col-lg-3">
                                        <label className="invisible"></label>
                                        <div>
                                            <button className="btn btn-success" onClick={DownloadReport}>
                                                <i className="fas fa-download me-1"></i>Download
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
             {loader && (
                            <Loader/>
                        )}
        </>
    )
}

export default Reports;